import WaveSurfer from 'wavesurfer.js'
import audio from '../../assets/audio/song.wav'
import React, { useEffect, useRef } from 'react'
import { FiPause, FiPlay } from 'react-icons/fi'

export const Waveform = ({ containerRef, style  }) => {
    // const containerRef = useRef()
  
    useEffect(() => {
      const waveSurfer = WaveSurfer.create({
        container: containerRef.current,
        container: "#waveform",
        // url: "/audio/song.wav",
        ...style,
       
      })
      waveSurfer.load(audio)

      return () => {
        waveSurfer.destroy()
      }
    }, [audio])
  
    const play = () => waveSurfer.play();
    const toggle = () => {}
    const pause = () => waveSurfer.pause();
    
    return (
      <React.Fragment>
         <div id="waveform"></div> 
         <div ref={containerRef} />
      </React.Fragment>
    )
  }
 
  export const WaveSurferWhite = () => {
    const containerRef = useRef()

    return (
      <React.Fragment>
        
        <div
          id="controls"
          class="mr-1 z-20 flex items-center justify-center left-0 right-0 top-0 bottom-0"
        >
          <div class="play" onClick={()=>{
            containerRef.waveSurfer.play()
          }}>
            <FiPlay size={23}
              class="stroke-none dark:fill-white fill-black"
            />
          </div>
          <div class="pause hidden"  onClick={()=>{
          }}>
            <FiPause
              class="stroke-none dark:fill-white fill-black"
            />
          </div>
        </div>

          <p className='w-full'>
          <Waveform
            containerRef={containerRef}
            style={{
              waveColor: "gray",
              progressColor: "black",
              height: 25,
              barWidth: 1,
              barHeight: 1,
              barGap: 4,
              barRadius: 15,
            }}
          />
          </p>
      </React.Fragment>
    )
  }